<template>
    <div class="pa-2 text-center">
      <v-dialog v-model="dialog" max-width="600">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn color="primary" variant="flat" prepend-icon="mdi-account-plus" v-bind="activatorProps">New Employee</v-btn>
        </template>

        <v-card prepend-icon="mdi-account" title="Create Account">
            <v-card-text>
                      <v-row dense>
                        <v-col cols="12" md="6" lg="6" sm="12">
                          <v-text-field
                            density="compact"
                            placeholder="Fullname*"
                            prepend-inner-icon="mdi-account-tie"
                            variant="outlined"
                            v-model="fullname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" sm="12">
                          <v-text-field
                            density="compact"
                            placeholder="Company Id*"
                            prepend-inner-icon="mdi-card-account-details"
                            variant="outlined"
                            v-model="company_id"
                          ></v-text-field>
                        </v-col>
  
                        <v-col cols="12" md="12" sm="12">
                          <v-text-field
                            density="compact"
                            placeholder="Email address*"
                            prepend-inner-icon="mdi-email-outline"
                            variant="outlined"
                            v-model="email"
                          ></v-text-field>
                        </v-col>
  
                        <v-col cols="12" sm="6">
                          <v-select
                            :items="teams"
                            label="Team*"
                            required
                            prepend-inner-icon="mdi-account-multiple"
                            variant="outlined"
                            v-model="team"
                            hint="Make sure the teams are already defined to create an employee account"
                          ></v-select>
                        </v-col>
  
                        <v-col cols="12" sm="6">
                          <v-select
                            :items="['Team Lead', 'Team Member']"
                            label="Role*"
                            v-model="role"
                            required
                            prepend-inner-icon="mdi-application"
                            variant="outlined"
                          ></v-select>
                        </v-col>
                      </v-row>
  
                      <small class="text-caption text-medium-emphasis">*indicates required field</small>
            </v-card-text>
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn text="Close" variant="plain" @click="dialog = false"></v-btn>
  
            <v-btn color="primary" text="Save" variant="flat" @click="createUser()"></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import constant from '@/constant';
  import utils from '@/utils';
  export default {
    name: "AddEmployee",
    data() {
        return {
            constant: constant,
            dialog: false,
            fullname: "",
            company_id: "",
            email: "",
            team: "",
            role: "",
            teams: [],
            message: ""
        }
    },
    methods: {
        getTeams(){
           axios.get(utils._api(this.constant.get_teams),{
                headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization' : `Bearer ${localStorage.getItem('token')}`
                    },
            }).then((response) => {
               const team_data = response.data.data.map((team) => ({
                id: team.id,
                team_name: team.team_name,
                team_desc: team.team_desc,
                }));
                team_data.forEach((team) => {
                this.teams.push(team.team_name);
                });
                this.isloading = false;
                // this.teams = response.data.data;
                console.log('Teams in add employee', response.data);
            }).catch(error => {
                console.error("Error fetching teams:", error);
            });
        },
        createUser(){
            const f = new FormData();
            f.append("fullname", this.fullname);
            f.append("company_id", this.company_id);
            f.append("email", this.email);
            f.append("team", this.team);
            f.append("role", this.role);
           axios.post(utils._api(this.constant.create_user),f , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization' : `Bearer ${localStorage.getItem('token')}`
                },
            }).then((response) => {
                this.isshow = !this.isshow;
                this.message = response.data.message;
                this.dialog = !this.dialog;
                this.company_id = "";
                this.fullname = "";
                this.email = "";
                this.team = "";
                this.role = "";
                this.$emit('toggle-message', this.message);
                this.dialog = false;
                // setTimeout(() => {
                //     this.$router.push({ name: 'dashboard' });
                // }, 5000);
                console.log(this.message);
            });
        }
    },
    mounted(){
        this.getTeams();
    },
    computed: {
      
    },
  }
  </script>
  